import { create } from 'zustand';
import { getGroupAttendance, getStudentAttendance, markAttendance as markAttendanceApi, updateAttendance, deleteAttendance, getAttendanceContextBySchedule, getAttendanceBySchedule } from '../api';
import useAdminAuthStore from './adminAuthStore';
import useAuthStore from './authStore';

const useAttendanceStore = create((set, get) => ({
  groupAttendance: [],
  studentAttendance: [],
  scheduleContext: null,
  scheduleAttendance: [],
  loading: false,
  error: null,

  async fetchGroupAttendance({ groupId, startDate, endDate }) {
    set({ loading: true, error: null });
    try {
      const { token } = useAdminAuthStore.getState();
      const data = await getGroupAttendance({ groupId, startDate, endDate, token });
      set({ groupAttendance: data, loading: false });
      return data;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },

  async fetchScheduleContext(scheduleId) {
    set({ loading: true, error: null });
    try {
      const { token } = useAdminAuthStore.getState();
      const data = await getAttendanceContextBySchedule({ scheduleId, token });
      set({ scheduleContext: data, loading: false });
      return data;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },

  async fetchStudentAttendance({ studentId, startDate, endDate, isAdmin = false }) {
    set({ loading: true, error: null });
    try {
      const token = isAdmin ? useAdminAuthStore.getState().token : useAuthStore.getState().token;
      const data = await getStudentAttendance({ studentId, startDate, endDate, token });
      set({ studentAttendance: data, loading: false });
      return data;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },

  async markAttendance(params) {
    set({ loading: true, error: null });
    try {
      const { token } = useAdminAuthStore.getState();
      const res = await markAttendanceApi({ ...params, token });
      set({ loading: false });
      return res;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },

  async fetchScheduleAttendance({ scheduleId, slotKey }) {
    set({ loading: true, error: null });
    try {
      const { token } = useAdminAuthStore.getState();
      const data = await getAttendanceBySchedule({ scheduleId, slotKey, token });
      set({ scheduleAttendance: data, loading: false });
      return data;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },

  async updateAttendance({ id, status, comment }) {
    set({ loading: true, error: null });
    try {
      const { token } = useAdminAuthStore.getState();
      const res = await updateAttendance({ id, status, comment, token });
      set({ loading: false });
      return res;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },

  async deleteAttendance(id) {
    set({ loading: true, error: null });
    try {
      const { token } = useAdminAuthStore.getState();
      const res = await deleteAttendance({ id, token });
      set({ loading: false });
      return res;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  }
}));

export default useAttendanceStore;


